import type { ProductLogoMediumProps } from "../types";

export function ProductLogoMediumEquipment({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 672 672"
      fill="none"
      {...props}
    >
      <rect width="672" height="672" rx="100" fill="#1A2142" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M312 336C318.627 336 324 341.373 324 348V492C324 498.627 318.627 504 312 504H168C161.373 504 156 498.627 156 492V348C156 341.373 161.373 336 168 336H312ZM188 456C183.582 456 180 459.582 180 464V472C180 476.418 183.582 480 188 480H208C212.418 480 216 476.418 216 472V464C216 459.582 212.418 456 208 456H188Z"
        fill="white"
      />
      <path
        d="M216 336H264V388C264 392.418 260.418 396 256 396H224C219.582 396 216 392.418 216 388V336Z"
        fill="#57D7D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M504 336C510.627 336 516 341.373 516 348V492C516 498.627 510.627 504 504 504H360C353.373 504 348 498.627 348 492V348C348 341.373 353.373 336 360 336H504ZM380 456C375.582 456 372 459.582 372 464V472C372 476.418 375.582 480 380 480H400C404.418 480 408 476.418 408 472V464C408 459.582 404.418 456 400 456H380Z"
        fill="white"
      />
      <path
        d="M408 336H456V388C456 392.418 452.418 396 448 396H416C411.582 396 408 392.418 408 388V336Z"
        fill="#57D7D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M408 144C414.627 144 420 149.373 420 156V300C420 306.627 414.627 312 408 312H264C257.373 312 252 306.627 252 300V156C252 149.373 257.373 144 264 144H408ZM284 264C279.582 264 276 267.582 276 272V280C276 284.418 279.582 288 284 288H304C308.418 288 312 284.418 312 280V272C312 267.582 308.418 264 304 264H284Z"
        fill="white"
      />
      <path
        d="M312 144H360V196C360 200.418 356.418 204 352 204H320C315.582 204 312 200.418 312 196V144Z"
        fill="#57D7D9"
      />
    </svg>
  );
}
